import { UserDto } from '../interfaces/dto/user.dto';
import { GroupDto } from '../interfaces/dto/group.dto';

export function isUserDto(item: UserDto | GroupDto): item is UserDto {
  return (item as UserDto).firstName !== undefined;
}
